import { Directive, input, TemplateRef } from '@angular/core';

@Directive({
    selector: '[pnToastTemplate]',
})
export class PnToastTemplate {
    name = input.required<'message' | 'headless'>({ alias: 'pnToastTemplate' });

    constructor(public templateRef: TemplateRef<unknown>) {}
}
